const PREFIX = 'USERS_';

const userConstants = {
  REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  UPDATE_PROFILE_REQUEST: 'USERS_UPDATE_PROFILE_REQUEST',
  UPDATE_PROFILE_SUCCESS: 'USERS_UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAILURE: 'USERS_UPDATE_PROFILE_FAILURE',

  REFRESH_REQUEST: 'USERS_REFRESH_REQUEST',
  REFRESH_SUCCESS: 'USERS_REFRESH_SUCCESS',
  REFRESH_FAILURE: 'USERS_REFRESH_FAILURE',

  RESEND_VERI_REQUEST: PREFIX + 'RESEND_VERI_REQUEST',
  RESEND_VERI_SUCCESS: PREFIX + 'RESEND_VERI_SUCCESS',
  RESEND_VERI_FAILURE: PREFIX + 'RESEND_VERI_FAILURE',

  SEND_RESETPASS_REQUEST: PREFIX + 'SEND_RESETPASS_REQUEST',
  SEND_RESETPASS_SUCCESS: PREFIX + 'SEND_RESETPASS_SUCCESS',
  SEND_RESETPASS_FAILURE: PREFIX + 'SEND_RESETPASS_FAILURE',
  SEND_RESETPASS_RESET: PREFIX + 'SEND_RESETPASS_RESET',

  RESETPASS_REQUEST: PREFIX + 'RESETPASS_REQUEST',
  RESETPASS_SUCCESS: PREFIX + 'RESETPASS_SUCCESS',
  RESETPASS_FAILURE: PREFIX + 'RESETPASS_FAILURE',
  RESETPASS_RESET: PREFIX + 'RESETPASS_RESET',

  LOGOUT: 'USERS_LOGOUT',

  FETCH_PROFILE_PERMISSION_REQUEST: PREFIX + 'FETCH_PROFILE_PERMISSION_REQUEST',
  FETCH_PROFILE_PERMISSION_SUCCESS: PREFIX + 'FETCH_PROFILE_PERMISSION_SUCCESS',
  FETCH_PROFILE_PERMISSION_FAILURE: PREFIX + 'FETCH_PROFILE_PERMISSION_FAILURE',

  UPDATE_PROFILE_PERMISSION_REQUEST:
    PREFIX + 'UPDATE_PROFILE_PERMISSION_REQUEST',
  UPDATE_PROFILE_PERMISSION_SUCCESS:
    PREFIX + 'UPDATE_PROFILE_PERMISSION_SUCCESS',
  UPDATE_PROFILE_PERMISSION_FAILURE:
    PREFIX + 'UPDATE_PROFILE_PERMISSION_FAILURE',
};

export default userConstants;
